//Below state legal age to apply for credit is 19
export const SPECIAL_AGE_STATES = {
    AL: 19,
    NE: 19,
    PR: 21
};

//Default age to apply for credit is 18
export const LEGAL_MIN_AGE = 18;

//Default max age to apply for credit is 130
export const LEGAL_MAX_AGE = 129;
